import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.model';
import { QuestionnaireStatusList } from '../interfaces/my-reservation.model';
import { API_ENDPOINTS } from '../constants/api.constants';

/**
 * 報到流程
 */
@Injectable({
  providedIn: 'root',
})
export class CheckinService {
  http: HttpClient = inject(HttpClient); 
  
  /**
   * 查詢同意書完成狀態 (CB-011)
   * @param idNo 身分證字號
   */
  getQuestionnaireStatus(idNo: string): Observable<ApiResponse<{ questionnaireStatusList: QuestionnaireStatusList[]; personalData: { name?: string; gender?: string; id?: string } }>> {
    const payload = { idNo };
    return this.http.post<ApiResponse<{ questionnaireStatusList: QuestionnaireStatusList[]; personalData: { name: string; gender: string; id: string } }>>(
      API_ENDPOINTS.GET_CONSENT_STATUS,
      payload
    );
  }
 
}